import { render, staticRenderFns } from "./GroupedEndorsementModal.vue?vue&type=template&id=5fce6306&"
import script from "./GroupedEndorsementModal.vue?vue&type=script&lang=js&"
export * from "./GroupedEndorsementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports